
// Copied from @ca/user-events

const UserEvents = {
  USER_ACCOUNT_CREATED: "user_account_created",
  ACCOUNT_CREATED: "account_created",

  NEW_ACCOUNT_STATE: "new_account_state",

  LOGIN_PASSWORD_SUCCESS: "login_password_success",
  LOGIN_OTP_SUCCESS: "login_otp_success",
  LOGIN_2FA_SUCCESS: "login_2fa_success",

  LOGIN_TOKEN_SUCCESS: "login_token_success",
  SET_PASSWORD_SUCCESS: "set_password_success",
  REQUEST_PASSWORD_RESET: "request_password_reset",
  LOGOUT: "logout",
  LOGIN_PASSWORD_FAIL: "login_password_fail",
  LOGIN_OTP_FAIL: "login_otp_fail",
  LOGIN_TOKEN_FAIL: "login_otp_fail",
  SET_PASSWORD_FAIL: "set_password_fail",

  ONBOARDING_NAV: "onboarding_nav",
  ONBOARDING_COMPLETED: "onboarding_completed",

  DOCUSIGN_STARTED: "docusign_started",
  DOCUSIGN_COMPLETED: "docusign_completed",
  DOCUSIGN_NOT_COMPLETED: "docusign_not_completed",

  KYC_START: "kyc_start",
  KYC_CANCEL: "kyc_cancel",
  KYC_END: "kyc_end",

  IAV_START: "iav_start",
  IAV_END: "iav_end",
  IAV_ADDED_PAYMENT_SOURCE: "iav_added_payment_source",
  IAV_CANCEL: "iav_cancel",
  IAV_ERROR: "iav_error",
}

export { UserEvents };
